module.exports = __webpack_public_path__ + "static/media/tela2.02630269.png";